import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { F1120SchcLine22Service } from './f1120-schc-line22.service';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-f1120-schc-line22',
    templateUrl: './f1120-schc-line22.component.html',
    styleUrls: ['./f1120-schc-line22.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class F1120SchcLine22Component implements OnInit, OnDestroy {
  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  minimise = false;
  crudLoading = false;

  modalTitle = 'Schedule C - Line 22 DRD Override';

  drdfdi: number | null = null;
  drdgilty: number | null = null;
  line22SumAmt: number = 0;

  rowData: any = {};
  colData: any = {};
  filterParams: any = {};
  globalService: any = {};
  globalParams: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};

  logged_in_user = '';
  modalLoading = false;
  private initialized = false;
  private saveSub: Subscription | null = null;
  private getSub: Subscription | null = null;

  constructor(
    private schcLine22Service: F1120SchcLine22Service,
    private _snackBar: MatSnackBar
  ) {}

  @Input('base-urls')
  set _base_urls(baseUrls: string) {
    try {
      if (baseUrls) {
        this.GENERAL_CONFIG.base_url = safeJsonInput<any>(baseUrls, null, 'f1120-schc-line22.parse1').base_url;
      }
    } catch (e) {
      // Base URLs input not yet stable
    }
  }

  @Input('header-data')
  set _header_data(headerData: string) {
    try {
      let data = safeJsonInput<any>(headerData, null, 'f1120-schc-line22.parse2');
      if (Object.keys(data).length > 0) {
        this.globalService = data;
        this.globalParams = data.globalParams || {};
        this.GENERAL_CONFIG = data.generalConfigData || {};
        this.USER_SETTINGS = data.userSettingsData || {};
        this.logged_in_user = this.USER_SETTINGS.user?.sso_id || '';
        this.init();
      }
    } catch (e) {
      // Header data input not yet stable
    }
  }

  @Input('row-data')
  set _row_data(rowData: string) {
    try {
      let data = safeJsonInput<any>(rowData, null, 'f1120-schc-line22.parse3');
      if (typeof data === 'string') {
        try { data = safeJsonInput<any>(data, null, 'f1120-schc-line22.parse4'); } catch (_) {}
      }
      if (Array.isArray(data) && data.length > 0) {
        this.rowData = data[0]?.data || data[0] || {};
      } else if (data?.data && typeof data.data === 'object') {
        this.rowData = data.data;
      } else {
        this.rowData = data || {};
      }
      this.init();
    } catch (e) {
      // Row data input not yet stable
    }
  }

  @Input('col-data')
  set _col_data(colData: string) {
    try {
      let data = safeJsonInput<any>(colData, null, 'f1120-schc-line22.parse5');
      this.colData = data || {};
    } catch (e) {
      // Col data input not yet stable
    }
  }

  @Input('filter-params')
  set _filter_params(filterParams: string) {
    try {
      let params = safeJsonInput<any>(filterParams, null, 'f1120-schc-line22.parse6');
      if (Object.keys(params).length > 0) {
        this.filterParams = params;
        this.init();
      }
    } catch (e) {
      // Filter params input not yet stable
    }
  }

  ngOnInit(): void {
    this.init();
  }

  init() {
    if (this.initialized) return;

    const hasRow    = this.rowData && Object.keys(this.rowData).length > 0;
    const hasConfig = this.GENERAL_CONFIG && this.GENERAL_CONFIG.base_url;

    if (hasRow && hasConfig) {
      this.initialized = true;
      this.drdfdi   = this.rowData.DRDFDI_AMT   != null ? Number(this.rowData.DRDFDI_AMT)   : null;
      this.drdgilty = this.rowData.DRDGILTY_AMT != null ? Number(this.rowData.DRDGILTY_AMT) : null;
      this.updateLine22Sum();
      this.loadModalData();
    }
  }

  loadModalData() {
    this.modalLoading = true;
    this.getSub = this.schcLine22Service.getModalData(
      this.GENERAL_CONFIG.base_url,
      this.rowData,
      this.globalService,
      this.filterParams
    ).subscribe(
      (response: any) => {
        this.modalLoading = false;
        const jsonObject = response?.jsonObject;
        const data = Array.isArray(jsonObject) ? jsonObject[0] : jsonObject;
        if (data) {
          this.drdfdi      = data.DRDFDI_AMT   != null ? Number(data.DRDFDI_AMT)   : this.drdfdi;
          this.drdgilty    = data.DRDGILTY_AMT != null ? Number(data.DRDGILTY_AMT) : this.drdgilty;
          this.line22SumAmt = data.LINE_22_SUM_AMT != null ? Number(data.LINE_22_SUM_AMT) : this.line22SumAmt;
        }
      },
      (error: any) => {
        this.modalLoading = false;
        console.error('[F1120SchcLine22] Error loading modal data:', error);
      }
    );
  }

  updateLine22Sum() {
    this.line22SumAmt = (this.drdfdi || 0) + (this.drdgilty || 0);
  }

  save() {
    if (this.crudLoading) return;
    this.crudLoading = true;

    console.log('[F1120SchcLine22] save() called — base_url:', this.GENERAL_CONFIG.base_url);

    const clobData = [{
      combination_key: this.rowData.COMBINATION_KEY || '',
      line_no:         this.rowData.LINE_NO          || '22',
      acct_key:        this.rowData.ACCT_KEY         || '',
      line_22_sum_amt: this.line22SumAmt,
      drdfdi:          this.drdfdi,
      drdgilty:        this.drdgilty
    }];

    const clobSetting = [{
      sso_id:     this.logged_in_user,
      screen_key: this.globalParams.screen_key || this.filterParams.screen_key || ''
    }];

    console.log('[F1120SchcLine22] calling saveOverride with clobData:', clobData);

    this.saveSub = this.schcLine22Service.saveOverride(
      this.GENERAL_CONFIG.base_url,
      clobData,
      clobSetting,
      'SAVE_F1120_SCHC_LINE22_OVERRIDE',
      this.logged_in_user,
      this.globalService,
      this.filterParams
    ).subscribe(
      (response: any) => {
        this.crudLoading = false;

        if (response.errorMessage && response.errorMessage !== 'null') {
          this._snackBar.open(response.errorMessage, 'Close', {
            duration: 4000,
            panelClass: ['error-snackbar']
          });
        } else {
          this._snackBar.open('Line 22 override saved successfully.', 'Close', {
            duration: 4000,
            panelClass: ['success-snackbar']
          });
          this.requestGridUpdate.emit('refresh');
        }
      },
      (error: any) => {
        this.crudLoading = false;
        console.error('[F1120SchcLine22] Error saving Line 22 override:', error);
        this._snackBar.open('Error occurred while saving. Please try again.', 'Close', {
          duration: 4000,
          panelClass: ['error-snackbar']
        });
      }
    );
  }

  ngOnDestroy(): void {
    this.saveSub?.unsubscribe();
    this.getSub?.unsubscribe();
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }
}
